import * as React from 'react';

import { connect } from 'react-redux';

import styled from 'styled-components';

import { CallHistoryMethodAction, push } from 'connected-react-router';
import { Dispatch } from 'redux';
import Success from '@components/success';

interface LabelRestoreSuccessPageProps {
  continueToLabel: () => CallHistoryMethodAction;
}

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    continueToLabel: () => dispatch(push(`/label`)),
  };
};

const LabelRestoreSuccessPage: React.FC<LabelRestoreSuccessPageProps> = ({
  continueToLabel,
}) => {
  return (
    <Success
      HEADING={'SUCCESS.LABEL.RESTORE.HEADING'}
      DESCRIPTION={'SUCCESS.LABEL.RESTORE.DESCRIPTION'}
      CONTINUE={'SUCCESS.LABEL.RESTORE.CONTINUE'}
      continueTo={continueToLabel}
    />
  );
};

export default connect(
  null,
  mapDispatchToProps
)(styled(LabelRestoreSuccessPage)`
  margin-top: 40px;
  padding-bottom: 200px;
  ${({ theme }) => `@media screen and ${theme.device.tablet}`} {
    margin-top: 80px;
  }
`);
